import { BicycleIcon } from './BicycleIcon';

/**
 * author: François Risoud
 * id 90DDBB60-0BBB-4DFA-9626-32D4D1FB34C5
 * name bicycle
 * version: 4.2.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/bicycle.svg
 * tags
 * - Transportation + Other 
 * - Sport 
 */
export const CyclingIcon = BicycleIcon;
export default CyclingIcon